import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useMemo, useState } from 'react';
import { IStyle } from 'Styles';
import HeaderBar from './HeaderBar';
import './CrystalContainer.scss';
import { dewarTableColumns, onCellChange, onDelete, preDelete } from './utils';
import { RMModal } from 'components/modal';
import { useFetchAllDewars } from './hooks';
export interface DewarProps {
  dewarInfo: any[];
  rowExtraInfo: any;
  setDewarInfo: React.Dispatch<React.SetStateAction<any[]>>;
  setInitialDewarInfo: React.Dispatch<React.SetStateAction<any[]>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setRowExtraInfo: React.Dispatch<React.SetStateAction<{}>>;
  deletedDewars: any[];
  inUseAlert?: (type: string) => void;
}

const DewarContent = (props: DewarProps) => {
  const {
    dewarInfo,
    rowExtraInfo,
    setDewarInfo,
    setInitialDewarInfo,
    setIsDirty,
    setRowExtraInfo,
    deletedDewars,
    inUseAlert,
  } = props;
  const [tableData, setTableData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([0]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onAdd = () => {
    const newDewarInfo = [...dewarInfo];
    const newDewarItem = {
      index: newDewarInfo.length,
      name: '',
      puckCount: '',
      rowIsDirty: true,
      enable: true,
      added: true,
    };
    newDewarInfo.push(newDewarItem);
    setDewarInfo(newDewarInfo);
    setSelectedIds([newDewarInfo.length - 1]);
  };
  // eslint-disable-next-line
  const renderTableData = useMemo(() => {
    const tempData = [...dewarInfo].map((dewar) => {
      return {
        name: (
          <input
            id="dewarcontent-input-name"
            type="text"
            style={dewar.name === '' ? styles.nameStyling : styles.nameStyling2}
            className="table-input-style"
            onChange={(e) =>
              onCellChange(
                e,
                'Dewar',
                dewar.index,
                'name',
                dewarInfo,
                setDewarInfo,
                setIsDirty,
                null,
                inUseAlert,
              )
            }
            value={dewar.name}
            title={dewar.name}
          />
        ),
        puckCount: (
          <input
            id="dewarcontent-input-puckcount"
            type="number"
            min="0"
            className="table-input-style"
            onChange={(e) =>
              onCellChange(
                e,
                'Dewar',
                dewar.index,
                'puckCount',
                dewarInfo,
                setDewarInfo,
                setIsDirty,
                null,
                inUseAlert,
              )
            }
            value={dewar.puckCount}
            title={dewar.puckCount}
          />
        ),
        enable: (
          <input
            id="dewarcontent-input-enable"
            style={styles.checkBox}
            type="checkbox"
            onChange={(e) =>
              onCellChange(
                e,
                'Dewar',
                dewar.index,
                'enable',
                dewarInfo,
                setDewarInfo,
                setIsDirty,
                null,
                inUseAlert,
              )
            }
            checked={dewar.enable}
            value={dewar.enable}
          />
        ),
      };
    });
    setTableData([...tempData]);
  }, [dewarInfo]);

  const onCheckboxSelectionChange = (rowIndices: number[]) => {
    setSelectedIds([...rowIndices]);
  };

  const handleOnRowCLick = (row) => {
    setSelectedIds([row.index]);
  };

  useFetchAllDewars(setDewarInfo, setInitialDewarInfo);
  return (
    <div
      id="dewarcontent-wrapper"
      className="flex-[1] flex flex-col h-[88vh] overflow-hidden m-1 border border-solid border-black"
    >
      <div id="dewarcontent-header">
        <HeaderBar
          title="Dewar Definition"
          onAdd={onAdd}
          onDelete={() =>
            onDelete(
              dewarInfo,
              selectedIds,
              'Dewar',
              setShowDeleteModal,
              setRowExtraInfo,
              setSelectedIds,
              inUseAlert,
            )
          }
          enableEditDelete={dewarInfo.length > 0 && selectedIds.length > 0}
        />
      </div>
      <div id="dewarcontent-table" className="overflow-auto">
        <RMTable
          columns={[...dewarTableColumns]}
          data={tableData}
          tableClass="rm-table-puck-dewar"
          selectedIds={selectedIds}
          enableMultiSelection={true}
          onCheckboxSelectionChange={onCheckboxSelectionChange}
          rowExtraInfo={rowExtraInfo}
          onRowClicked={handleOnRowCLick}
        />
      </div>
      {dewarInfo.length > 0 && selectedIds.length > 0 && (
        <RMModal
          showModal={showDeleteModal}
          setShowModal={setShowDeleteModal}
          onOk={() =>
            preDelete(
              dewarInfo,
              setDewarInfo,
              selectedIds,
              setShowDeleteModal,
              setIsDirty,
              deletedDewars,
            )
          }
          body={'Are you sure you want to delete this item?'}
          heading={`Delete Dewar`}
          okButtonText={'CONFIRM'}
        />
      )}
    </div>
  );
};

const styles: IStyle = {
  dewarContent: {
    border: '1px solid gray',
    flex: 1,
    margin: '5px 5px',
  },
  nameStyling1: {
    border: '2px solid #DB0000',
    borderRadius: '2px',
    outline: 'none',
    textAlign: 'left',
  },
  nameStyling2: {
    textAlign: 'left',
  },
  checkBox: {
    height: '1.4rem',
  },
};
export default DewarContent;
